import { object, boolean, string, array } from 'yup';
// import { object, boolean, string, array, addMethod } from 'yup';
// import { contacts as contactsApi } from '@afosto/contacts/api/Contacts';
import addEmailValidation from '@afosto/utils-react/validators/validEmail';

addEmailValidation();

// TODO: add try catch and different implementation of search
// eslint-disable-next-line func-names
// addMethod(string, 'emailAlreadyUsed', function () {
//   return this.test({
//     name: 'emailAlreadyUsed',
//     message: 'Email already in use',
//     async test(email = '') {
//       const { id } = this.parent;
//
//       if (email && !id) {
//         const response = await contactsApi.searchContacts({
//           constraints: [
//             {
//               key: 'email',
//               operator: 'in',
//               value: [email],
//             },
//           ],
//         });
//         const contacts = response.data.filter(contact => !contact.deleted_at);
//         return contacts.length === 0;
//       }
//
//       return true;
//     },
//   });
// });

export default object().shape({
  isSameContact: boolean(),
  givenName: string().required(),
  familyName: string().required(),
  additionalName: string(),
  // email: string().validEmail().emailAlreadyUsed().required(),
  email: string().validEmail().required(),
  audience: string().required(),
  tags: array().of(string()),
});
